import * as React from "react";
import ReactDOM = require("react-dom")
import { browserHistory, Router } from "react-router"

import { addApi } from "../Component/url"
import { SimpleComponent } from "../Component/SimpleComponent"
import { showErrorPopup, showDialog } from "../Component/popups"

import { appContext } from "./appContext"
import { routes } from "./routes"

interface IAppClientProps { }

appContext.requester = {
    get: (url: string, consumer: (result: any, error: any) => void) => {
        $.ajax({
            dataType: "json",
            url: addApi(url),
            success: (result: any) => consumer(result, null),
            error: (error: JQueryXHR, textStatus: string, errorThrown: string) => consumer(null, error.responseJSON)
        });
    },
    post: (url: string, request: any, consumer: (result: any, error: any) => void) => {
        $.ajax({
            type: "POST",
            url: addApi(url),
            data: JSON.stringify(request),
            dataType: "json",
            contentType: "application/json",
            processData: false,
            success: (result: any) => consumer(result, null),
            error: (error: JQueryXHR, textStatus: string, errorThrown: string) => consumer(null, error.responseJSON)
        });
    }
}

class AppClient extends SimpleComponent<IAppClientProps> {
    constructor(props: IAppClientProps) { super(props); }
    render() {
        appContext.refresh = () => this.forceUpdate();
        return <Router history={browserHistory}>{routes}</Router>;
    }
}

export function clientEntry(
    mountNode: HTMLElement,
    cacheWithStrings: Object,
    redigerbar: boolean,
    visning: string,
    innloggetBruker: string,
    visSomAktorId: number | undefined,
    effektivAktørEpost: string | undefined,
    effektivAktørNavn: string | undefined,
    effektivAktørRelasjon: Gf.Dom.Type.AktørrelasjonType | undefined,
    testServer: boolean,
    plassering: string,
    erTffAnsatt: boolean) {
    appContext.server = false;
    appContext.cache.importWithStrings(cacheWithStrings);
    appContext.redigerbar = redigerbar;
    appContext.visning = visning;
    appContext.dialogShower = {
        showModal: (popup: any) => ReactDOM.render(popup, document.getElementById("modalParent") as Element),
        showErrorPopup: (message: String[]) => showErrorPopup(message),
        showDialog: (message: string, action: () => void) => showDialog(message, action)
    };
    appContext.innloggetBruker = innloggetBruker;
    appContext.visSomAktorId = visSomAktorId;
    appContext.effektivAktørEpost = effektivAktørEpost;
    appContext.effektivAktørNavn = effektivAktørNavn;
    appContext.effektivAktørRelasjon = effektivAktørRelasjon;
    appContext.erTffAnsatt = erTffAnsatt;
    appContext.getCurrentLocation = () => window.location.pathname + window.location.search;
    appContext.setTimeout = (handler: () => void, timeout: number) => setTimeout(handler, timeout);
    appContext.testServer = testServer;
    appContext.plassering = plassering;
    appContext.log = (message: string) => console.log(message);

    ReactDOM.render(<AppClient />, mountNode);
}




// WEBPACK FOOTER //
// ./Scripts/React/App/appClient.tsx